import { getConfigLists } from '../helpers';

export async function getUsedInventory(storeNumbers) {
  const { usedEquipmentApiBaseUrl } = getConfigLists();
  const baseUrl = `${usedEquipmentApiBaseUrl}/usedInventoryApi.php`;
  const storeList = storeNumbers.join(',');
  const url = `${baseUrl}?StrNbr=${encodeURIComponent(storeList)}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Inventory API error: ${response.status}`);
  }
  return response.json();
}
